import script from "./BarcodeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BarcodeCard.vue?vue&type=script&setup=true&lang=js"

import "./BarcodeCard.vue?vue&type=style&index=0&id=7275791b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7275791b"]])

export default __exports__